/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect } from 'react';
import Input from '../../components/Input/Input';
import {
  customerInputArray,
  errorObjectType,
  formObjectType
} from '../../types/regulatoryUpdateBundle';
import PhoneEmailInput from '../PhoneEmailInput/PhoneEmailInput';

type FormProps = {
  loginCheck: boolean;
  customerForm: boolean;
  title: string;
  formObject: formObjectType;
  setFormObjectValue: Function;
  errorCondition: errorObjectType;
  removeErrorOnFocus: Function;
  phoneFomaterError?: boolean;
  setPhoneFomaterError?: React.Dispatch<React.SetStateAction<boolean>>;
};

const Form = (props: FormProps): JSX.Element => {
  const setUserInfoInStateObject = (value, name) => {
    let customerInfo = props.formObject;

    customerInfo = { ...customerInfo, [name]: value };
    props.setFormObjectValue(customerInfo);
  };

  let emailPhoneStateFunction = (inputType: string) => {
    return function (value) {
      let customerInfo = props.formObject;
      customerInfo = { ...customerInfo, [inputType]: value };
      props.setFormObjectValue(customerInfo);
    };
  };
  const removeErrorOnFocus = function (value) {
    let title = props.title;
    props.removeErrorOnFocus(value, title);
  };
  const getPassingObject = (inputType) => {
    let phone = inputType === 'phone';
    let setInputValueFunction = emailPhoneStateFunction(inputType);
    return {
      inputValue: phone ? props.formObject.phone : props.formObject.email,
      placeHolder: phone ? 'Please Enter Phone' : 'Please Enter Email ',
      inputType: inputType,
      setInputValue: setInputValueFunction,
      useDefualtError: props.phoneFomaterError,
      removeErrorOnFocusProp: removeErrorOnFocus
    };
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {}, [props.errorCondition]);

  return (
    <div>
      {props.loginCheck && props.customerForm && (
        <div className="regulatory-updates-modal__values">
          <h2 className="privacy-ccpa__form-heading">
            {props.title}&apos;s information
          </h2>
          <div className="regulatory-updates-modal__values-area">
            <Input
              type="text"
              placeholder={customerInputArray[0].placeHolder}
              value={props.formObject.firstName}
              name={customerInputArray[0].name}
              className="regulatory-updates__input-value real-time-val greyBackground"
              size={30}
              onChange={(e) =>
                setUserInfoInStateObject(
                  e.target.value,
                  customerInputArray[0].name
                )
              }
              onFocus={() =>
                props.removeErrorOnFocus(
                  customerInputArray[0].name,
                  props.title
                )
              }
            />
            {props.errorCondition.firstNameError && (
              <span className="real-time-error">
                First Name cannot be empty.
              </span>
            )}
            <div className="real-time-error"></div>
          </div>
          <div className="regulatory-updates-modal__values-area">
            <Input
              type="text"
              placeholder={customerInputArray[1].placeHolder}
              value={props.formObject.lastName}
              name={customerInputArray[1].name}
              className="regulatory-updates__input-value real-time-val greyBackground"
              size={30}
              onChange={(e) =>
                setUserInfoInStateObject(
                  e.target.value,
                  customerInputArray[1].name
                )
              }
              onFocus={() =>
                props.removeErrorOnFocus(
                  customerInputArray[1].name,
                  props.title
                )
              }
            />
            {props.errorCondition.lastNameError && (
              <span className="real-time-error">
                Last Name cannot be empty.
              </span>
            )}
            <div className="real-time-error"></div>
          </div>
          <div className="regulatory-updates-modal__values-area">
            <PhoneEmailInput
              {...getPassingObject('email')}
              name={customerInputArray[2].name}
            />
            {props.errorCondition.emailBlankError && (
              <span className="real-time-error">Email cannot be empty.</span>
            )}
            {props.errorCondition.emailIncorrectError && (
              <span className="real-time-error">Email incorrect.</span>
            )}
            <div className="real-time-error"></div>
          </div>
          <div className="regulatory-updates-modal__values-area regulatory-updates-modal__values-area--phno">
            <div className="regulatory-updates-modal__info">
              <PhoneEmailInput
                {...getPassingObject('phone')}
                name={customerInputArray[3].name}
              />
              {props.errorCondition.phoneBlankError && (
                <span className="real-time-error">
                  Phone Number cannot be empty.
                </span>
              )}
              {props.errorCondition.phoneIncorrectError && (
                <span className="real-time-error">
                  Please enter valid phone number.
                </span>
              )}
              <div className="real-time-error"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Form;
